module.exports = __webpack_public_path__ + "static/367117_1_0-cb893222a74cba0368f021b397667a60.ttf";